import React, { useState } from "react";

const DropdownInput = ({
	items,
	title,
	activeObj,
	onValueChange,
	isRequired
}) => {
	const [activeItem, SetActiveItem] = useState(activeObj);
	const data = items || [];

	const HandleActiveItem = item => {
		if (item) SetActiveItem(item);
	};
	// console.log("List of data passed: ", data);
	// console.log("Active data passed: ", activeItem);

	return (
		<>
			<div className="form-group">
				<label className="control-label">
					{title}
					{isRequired && <span className="required"> * </span>}
				</label>

				<select
					value={activeItem && activeItem.id}
					onChange={e => {
						data.forEach(s => {
							if (s.id === e.target.value) {
								HandleActiveItem(s);
								onValueChange(s);
							}
						});
					}}
					className="form-control input-height"
					required={isRequired}
				>
					<option value="">Select {title}...</option>
					{data.map(item => (
						<option key={item.id} value={item.id}>
							{item.name}
						</option>
					))}
				</select>
			</div>
		</>
	);
};

export default DropdownInput;
